import { Modal, ModalSection, Button } from '@monash/portal-react';
import c from './feedback-modal.module.scss';

const ConfirmationModal = ({ open, title, message, onConfirm, onCancel }) => {
  return (
    <Modal open={open} onClose={onCancel} ariaLabel={title}>
      <ModalSection title={title}>
        <p>{message}</p>
        <div className={c.modalButtons}>
          <Button variant="secondary" size="medium" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="delete" size="medium" onClick={onConfirm}>
            Discard
          </Button>
        </div>
      </ModalSection>
    </Modal>
  );
};

export default ConfirmationModal;
